import {css} from '@emotion/react';
import styled from '@emotion/styled';
import {Box} from '@mui/material';

import {mixinSVGIcon} from '../styles/mixins';

export const EBox = styled(Box)``;

const mixinInfobox = css`
  padding: var(--gutter-little);
  border-radius: var(--card-border-radius);
  overflow-wrap: break-word;

  svg {
    ${mixinSVGIcon}
  }

  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  gap: var(--gutter-small);
`;

export const EInfobox = styled.div`
  ${mixinInfobox}
  background-color: var(--infobox-background-color);
  color: var(--color-core-primary);
`;

export const EWarningBox = styled.div`
  ${mixinInfobox}
  background-color: var(--warningbox-background-color);
  color: var(--color-core-white);
`;
